<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="cash-outline"></ion-icon> Financial</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Finance is the key metric for an Incubator. It is important to
              have adequate financial resources for sustaining business
              operations and to fund the client Startups.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Sources of Funding Support for Startups (Grants and Government
              Aid); Sources of Private Investments for Startups (Angel
              Investment and Venture Capital); Revenue Sources for the
              Incubator. Incubators may also work with Banks to secure loans and
              Credit lines to startups which are eligible under different
              schemes.
            </li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    External funding received by the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.externalfundingStatus)"
                    [style.background]="
                      pickColor(getValue.externalfundingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.externalfundingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>External funding received by the Incubation Centre</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.externalfundingStatus != 2 &&
                        getValue.externalfundingStatus != 4 &&
                        getValue.externalfundingStatus != 5 &&
                        getValue.externalfundingStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="externalfundingCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options6checked"
                          (change)="
                            showOptions6(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.externalfundingCentre.touched &&
                              setting.externalfundingCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.externalfundingCentre.touched &&
                            setting.externalfundingCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.externalfundingCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options6checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of funding support received
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of External funding received"
                                (change)="
                                  setStatus($event, 'externalfundingStatus', 7)
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="externalfundingNooffunding"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.externalfundingNooffunding
                                      .touched &&
                                    setting.externalfundingNooffunding.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.externalfundingNooffunding.touched &&
                                  setting.externalfundingNooffunding.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.externalfundingNooffunding.errors
                                      .required
                                  "
                                  >No. of External funding received</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload5">
                                  <input
                                    type="file"
                                    formControlName="externalfundingImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.externalfundingImagefile
                                          .touched &&
                                        setting.externalfundingImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload5',
                                        5,
                                        '.set-succ5'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.externalfundingImagefile.touched &&
                                    setting.externalfundingImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.externalfundingImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload5"
                                  (click)="
                                    removeFile('.upload5', 5, '.set-succ5')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.externalfundingStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.externalfundingReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.externalfundingStatus == 2 ||
                        getValue.externalfundingStatus == 4 ||
                        getValue.externalfundingStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.externalfundingCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of External funding received:
                            <b>{{ getValue.externalfundingNooffunding }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.externalfundingdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.externalfundingStatus == 3 ||
                            getValue.externalfundingStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.externalfundingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Access to funding for Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.accessToFundingStatus)"
                    [style.background]="
                      pickColor(getValue.accessToFundingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.accessToFundingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Access to funding for Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.accessToFundingStatus != 2 &&
                        getValue.accessToFundingStatus != 4 &&
                        getValue.accessToFundingStatus != 5 &&
                        getValue.accessToFundingStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="accessToFundingIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsonechecked"
                          (change)="
                            showOptionsone(
                              $event.value,
                              '.upload0',
                              0,
                              '.set-succ0'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.accessToFundingIncCentre.touched &&
                              setting.accessToFundingIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.accessToFundingIncCentre.touched &&
                            setting.accessToFundingIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.accessToFundingIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsonechecked">
                        <div class="main-wrapper" *ngSwitchCase="'Yes'">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload0">
                              <input
                                type="file"
                                formControlName="accessToFundingImagefile"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload0',
                                    0,
                                    '.set-succ0'
                                  )
                                "
                                id=""
                                [ngClass]="{
                                  'is-invalid':
                                    setting.accessToFundingImagefile.touched &&
                                    setting.accessToFundingImagefile.errors
                                }"
                              />

                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary
                              </span>
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                        27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Successfully</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.accessToFundingImagefile.touched &&
                                setting.accessToFundingImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.accessToFundingImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload0"
                              (click)="removeFile('.upload0', 0, '.set-succ0')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.accessToFundingStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.accessToFundingReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.accessToFundingStatus == 2 ||
                        getValue.accessToFundingStatus == 4 ||
                        getValue.accessToFundingStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.accessToFundingIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.accessToFundingDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.accessToFundingStatus == 3 ||
                            getValue.accessToFundingStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.accessToFundingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Any seed fund availed by Startups in Incubators from
                    Government or Private Organizations
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.seedfundAvailedStatus)"
                    [style.background]="
                      pickColor(getValue.seedfundAvailedStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.seedfundAvailedStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Any seed fund availed by Startups in Incubators from
                      Government or Private Organizations
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.seedfundAvailedStatus != 2 &&
                        getValue.seedfundAvailedStatus != 4 &&
                        getValue.seedfundAvailedStatus != 5 &&
                        getValue.seedfundAvailedStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="seedfundAvailedIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionstwochecked"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.seedfundAvailedIncCentre.touched &&
                              setting.seedfundAvailedIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.seedfundAvailedIncCentre.touched &&
                            setting.seedfundAvailedIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.seedfundAvailedIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionstwochecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter  No. of Startups "
                                (change)="
                                  setStatus($event, 'seedfundAvailedStatus', 7)
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="seedfundAvailedNoOfStartups"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.seedfundAvailedNoOfStartups
                                      .touched &&
                                    setting.seedfundAvailedNoOfStartups.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.seedfundAvailedNoOfStartups.touched &&
                                  setting.seedfundAvailedNoOfStartups.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.seedfundAvailedNoOfStartups.errors
                                      .required
                                  "
                                  >No. of Startups
                                </span>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="seedfundAvailedImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.seedfundAvailedImagefile
                                          .touched &&
                                        setting.seedfundAvailedImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                        27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.seedfundAvailedImagefile.touched &&
                                    setting.seedfundAvailedImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.seedfundAvailedImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.seedfundAvailedStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.seedfundAvailedReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.seedfundAvailedStatus == 2 ||
                        getValue.seedfundAvailedStatus == 4 ||
                        getValue.seedfundAvailedStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.seedfundAvailedIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.seedfundAvailedNoOfStartups }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.seedFundAvailedDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.seedfundAvailedStatus == 3 ||
                            getValue.seedfundAvailedStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.seedfundAvailedReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Programs / Schemes for Startups (Incentives, Seed Grants,
                    Market Access, etc.)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.programsschemesStatus)"
                    [style.background]="
                      pickColor(getValue.programsschemesStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.programsschemesStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Programs / Schemes for Startups (Incentives, Seed Grants,
                      Market Access, etc.)
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.programsschemesStatus != 2 &&
                        getValue.programsschemesStatus != 4 &&
                        getValue.programsschemesStatus != 5 &&
                        getValue.programsschemesStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="programsschemesIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions7(
                              $event.value,
                              '.upload6',
                              6,
                              '.set-succ6'
                            )
                          "
                          [(ngModel)]="Options7checked"
                          [ngClass]="{
                            'is-invalid':
                              setting.programsschemesIncCentre.touched &&
                              setting.programsschemesIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.programsschemesIncCentre.touched &&
                            setting.programsschemesIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.programsschemesIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options7checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website<span
                                  class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="programsschemesUrlIcWebsite"
                                (change)="
                                  setStatus($event, 'programsschemesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.programsschemesUrlIcWebsite
                                      .touched &&
                                    setting.programsschemesUrlIcWebsite.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.programsschemesUrlIcWebsite.touched &&
                                  setting.programsschemesUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.programsschemesUrlIcWebsite.errors
                                      .required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.programsschemesUrlIcWebsite.errors
                                      .url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs / Schemes<span
                                  class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder=" No. of Programs / Schemes"
                                formControlName="programsschemesNoofPrograms"
                                (change)="
                                  setStatus($event, 'programsschemesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.programsschemesNoofPrograms
                                      .touched &&
                                    setting.programsschemesNoofPrograms.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.programsschemesNoofPrograms.touched &&
                                  setting.programsschemesNoofPrograms.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.programsschemesNoofPrograms.errors
                                      .required
                                  "
                                  >No. of Programs / Schemes</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload6">
                                  <input
                                    type="file"
                                    formControlName="programsschemesImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload6',
                                        6,
                                        '.set-succ6'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.programsschemesImagefile
                                          .touched &&
                                        setting.programsschemesImagefile.errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload File</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Uploading</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.programsschemesImagefile.touched &&
                                    setting.programsschemesImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.programsschemesImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload6"
                                  (click)="
                                    removeFile('.upload6', 6, '.set-succ6')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove File</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.programsschemesStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.programsschemesReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.programsschemesStatus == 2 ||
                        getValue.programsschemesStatus == 4 ||
                        getValue.programsschemesStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs / Schemes :
                            <b>{{ getValue.programsschemesNoofPrograms }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.programsschemesUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{ getValue.programsschemesUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.programsSchemesDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.programsschemesStatus == 3 ||
                            getValue.programsschemesStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.programsschemesReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Creation of Private Investments channels for Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.privateInvChannelsStatus)"
                    [style.background]="
                      pickColor(getValue.privateInvChannelsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.privateInvChannelsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Creation of Private Investments channels for Startups
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.privateInvChannelsStatus != 2 &&
                        getValue.privateInvChannelsStatus != 4 &&
                        getValue.privateInvChannelsStatus != 5 &&
                        getValue.privateInvChannelsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="privateInvChannelsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsthreechecked"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.privateInvChannelsIncCentre.touched &&
                              setting.privateInvChannelsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.privateInvChannelsIncCentre.touched &&
                            setting.privateInvChannelsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.privateInvChannelsIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsthreechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website<span
                                  class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="privateInvChannelsUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'privateInvChannelsStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.privateInvChannelsUrlIcWebsite
                                      .touched &&
                                    setting.privateInvChannelsUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.privateInvChannelsUrlIcWebsite
                                    .touched &&
                                  setting.privateInvChannelsUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.privateInvChannelsUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.privateInvChannelsUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload2">
                                  <input
                                    type="file"
                                    formControlName="privateInvChannelsImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.privateInvChannelsImagefile
                                          .touched &&
                                        setting.privateInvChannelsImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload2',
                                        2,
                                        '.set-succ2'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Screenshot</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.privateInvChannelsImagefile
                                      .touched &&
                                    setting.privateInvChannelsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.privateInvChannelsImagefile.errors
                                        .required
                                    "
                                    >Screenshot is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload2"
                                  (click)="
                                    removeFile('.upload2', 2, '.set-succ2')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Screenshot</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.privateInvChannelsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.privateInvChannelsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.privateInvChannelsStatus == 2 ||
                        getValue.privateInvChannelsStatus == 4 ||
                        getValue.privateInvChannelsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.privateInvChannelsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.privateInvChannelsUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.privateInvChannelsUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.privateInvChannelsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.privateInvChannelsStatus == 3 ||
                            getValue.privateInvChannelsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.privateInvChannelsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Formal MoU with Angel Investors and Venture Capital Funding
                    / With Banks for providing loans and Credit lines to
                    eligible startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.formalmouStatus)"
                    [style.background]="pickColor(getValue.formalmouStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.formalmouStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Formal MoU with Angel Investors and Venture Capital
                      Funding / With Banks for providing loans and Credit lines
                      to eligible startups
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.formalmouStatus != 2 &&
                        getValue.formalmouStatus != 4 &&
                        getValue.formalmouStatus != 5 &&
                        getValue.formalmouStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="formalmouCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options8checked"
                          (change)="
                            showOptions8(
                              $event.value,
                              '.upload7',
                              7,
                              '.set-succ7'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.formalmouCentre.touched &&
                              setting.formalmouCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.formalmouCentre.touched &&
                            setting.formalmouCentre.errors
                          "
                        >
                          <span *ngIf="setting.formalmouCentre.errors.required"
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options8checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of MoUs / LoIs
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of MoUs / LoIs"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="formalmouNoofmou"
                                (change)="
                                  setStatus($event, 'formalmouStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.formalmouNoofmou.touched &&
                                    setting.formalmouNoofmou.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.formalmouNoofmou.touched &&
                                  setting.formalmouNoofmou.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.formalmouNoofmou.errors.required
                                  "
                                  >No. of MoUs / LoIs</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload7">
                                  <input
                                    type="file"
                                    formControlName="formalmouImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.formalmouImagefile.touched &&
                                        setting.formalmouImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload7',
                                        7,
                                        '.set-succ7'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.formalmouImagefile.touched &&
                                    setting.formalmouImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.formalmouImagefile.errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload7"
                                  (click)="
                                    removeFile('.upload7', 7, '.set-succ7')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.formalmouStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.formalmouReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.formalmouStatus == 2 ||
                        getValue.formalmouStatus == 4 ||
                        getValue.formalmouStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.formalmouCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of MoUs / LoIs :
                            <b>{{ getValue.formalmouNoofmou }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="let list of getValue.formalmoudocuments"
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.formalmouStatus == 3 ||
                            getValue.formalmouStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.revenueModelReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Provision of Equity funding / Angel Investments / Venture
                    Capital funding through Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.provisionofequityStatus)"
                    [style.background]="
                      pickColor(getValue.provisionofequityStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.provisionofequityStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Provision of Equity funding / Angel Investments / Venture
                      Capital funding through Incubation Centre
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.provisionofequityStatus != 2 &&
                        getValue.provisionofequityStatus != 4 &&
                        getValue.provisionofequityStatus != 5 &&
                        getValue.provisionofequityStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="provisionofequityCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options9checked"
                          (change)="
                            showOptions9(
                              $event.value,
                              '.upload8',
                              8,
                              '.set-succ8'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.provisionofequityCentre.touched &&
                              setting.provisionofequityCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.provisionofequityCentre.touched &&
                            setting.provisionofequityCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.provisionofequityCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options9checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="provisionofequityUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'provisionofequityStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.provisionofequityUrlIcWebsite
                                      .touched &&
                                    setting.provisionofequityUrlIcWebsite.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.provisionofequityUrlIcWebsite
                                    .touched &&
                                  setting.provisionofequityUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.provisionofequityUrlIcWebsite.errors
                                      .required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.provisionofequityUrlIcWebsite.errors
                                      .url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Startups"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="provisionofequityNoofstartups"
                                (change)="
                                  setStatus(
                                    $event,
                                    'provisionofequityStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.provisionofequityNoofstartups
                                      .touched &&
                                    setting.provisionofequityNoofstartups.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.provisionofequityNoofstartups
                                    .touched &&
                                  setting.provisionofequityNoofstartups.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.provisionofequityNoofstartups.errors
                                      .required
                                  "
                                  >No of No. of Startups</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload8">
                                  <input
                                    type="file"
                                    formControlName="provisionofequityImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.provisionofequityImagefile
                                          .touched &&
                                        setting.provisionofequityImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload8',
                                        8,
                                        '.set-succ8'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.provisionofequityImagefile
                                      .touched &&
                                    setting.provisionofequityImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.provisionofequityImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload8"
                                  (click)="
                                    removeFile('.upload8', 8, '.set-succ8')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.provisionofequityStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.provisionofequityReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.provisionofequityStatus == 2 ||
                        getValue.provisionofequityStatus == 4 ||
                        getValue.provisionofequityStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.provisionofequityCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website :
                            <b>{{ getValue.provisionofequityUrlIcWebsite }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Startups :
                            <b>{{ getValue.provisionofequityNoofstartups }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="let list of getValue.incentivesDocuments"
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.provisionofequityStatus == 3 ||
                            getValue.provisionofequityStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.incentivesReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Incentives for Women Led Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.incentivesStatus)"
                    [style.background]="pickColor(getValue.incentivesStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.incentivesStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Incentives for Women Led Startups</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.incentivesStatus != 2 &&
                        getValue.incentivesStatus != 4 &&
                        getValue.incentivesStatus != 5 &&
                        getValue.incentivesStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="incentivesIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfourchecked"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.incentivesIncCentre.touched &&
                              setting.incentivesIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.incentivesIncCentre.touched &&
                            setting.incentivesIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="setting.incentivesIncCentre.errors.required"
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfourchecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="incentivesUrlIcWebsite"
                                (change)="
                                  setStatus($event, 'incentivesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incentivesUrlIcWebsite.touched &&
                                    setting.incentivesUrlIcWebsite.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.incentivesUrlIcWebsite.touched &&
                                  setting.incentivesUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.incentivesUrlIcWebsite.errors
                                      .required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.incentivesUrlIcWebsite.errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                            <div class="form-rows mb-2">
                              <mat-label class="">
                                Incentives for Students
                                <span class="text-danger">*</span></mat-label
                              >
                              <br />
                              <mat-radio-group
                                class="example-margin"
                                aria-label="Select an option"
                                (change)="
                                  setStatus($event, 'incentivesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incentivesStudents.touched &&
                                    setting.incentivesStudents.errors
                                }"
                                formControlName="incentivesStudents"
                              >
                                <mat-radio-button value="Yes"
                                  >Yes</mat-radio-button
                                >
                                <mat-radio-button value="No"
                                  >No</mat-radio-button
                                >
                                <mat-error
                                  *ngIf="
                                    setting.incentivesStudents.touched &&
                                    setting.incentivesStudents.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.incentivesStudents.errors.required
                                    "
                                    >Incentives for Students is required</span
                                  >
                                </mat-error>
                              </mat-radio-group>
                            </div>
                            <div class="form-rows mb-2">
                              <mat-label class="">
                                Incentives for Women Led Startups
                                <span class="text-danger">*</span></mat-label
                              >
                              <br />
                              <mat-radio-group
                                class="example-margin"
                                aria-label="Select an option"
                                (change)="
                                  setStatus($event, 'incentivesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incentivesWomenStudents.touched &&
                                    setting.incentivesWomenStudents.errors
                                }"
                                formControlName="incentivesWomenStudents"
                              >
                                <mat-radio-button value="Yes"
                                  >Yes</mat-radio-button
                                >
                                <mat-radio-button value="No"
                                  >No</mat-radio-button
                                >
                                <mat-error
                                  *ngIf="
                                    setting.incentivesWomenStudents.touched &&
                                    setting.incentivesWomenStudents.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.incentivesWomenStudents.errors
                                        .required
                                    "
                                    >Incentives for Women Led Startups is
                                    required</span
                                  >
                                </mat-error>
                              </mat-radio-group>
                            </div>
                            <div class="form-rows mb-2">
                              <mat-label class="">
                                Incentives for Other Social Category
                                <span class="text-danger">*</span></mat-label
                              >
                              <br />
                              <mat-radio-group
                                class="example-margin"
                                aria-label="Select an option"
                                (change)="
                                  setStatus($event, 'incentivesStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.incentivesSocialCategory.touched &&
                                    setting.incentivesSocialCategory.errors
                                }"
                                formControlName="incentivesSocialCategory"
                              >
                                <mat-radio-button value="Yes"
                                  >Yes</mat-radio-button
                                >
                                <mat-radio-button value="No"
                                  >No</mat-radio-button
                                >
                                <mat-error
                                  *ngIf="
                                    setting.incentivesSocialCategory.touched &&
                                    setting.incentivesSocialCategory.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.incentivesSocialCategory.errors
                                        .required
                                    "
                                    >Incentives for Other Social Category is
                                    required</span
                                  >
                                </mat-error>
                              </mat-radio-group>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload3">
                                  <input
                                    type="file"
                                    formControlName="incentivesImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.incentivesImagefile.touched &&
                                        setting.incentivesImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload3',
                                        3,
                                        '.set-succ3'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.incentivesImagefile.touched &&
                                    setting.incentivesImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.incentivesImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload3"
                                  (click)="
                                    removeFile('.upload3', 3, '.set-succ3')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.incentivesStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.incentivesReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.incentivesStatus == 2 ||
                        getValue.incentivesStatus == 4 ||
                        getValue.incentivesStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.incentivesIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{ getValue.incentivesUrlIcWebsite }}"
                                target="_blank"
                                >{{ getValue.incentivesUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Incentives for Students :
                            <b>{{ getValue.incentivesStudents }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Incentives for Women Led Startups :
                            <b>{{ getValue.incentivesWomenStudents }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Incentives for Other Social Category :
                            <b>{{ getValue.incentivesSocialCategory }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="let list of getValue.incentivesDocuments"
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.incentivesStatus == 3 ||
                            getValue.incentivesStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.incentivesReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Revenue Model / Fund generation for Sustainability (Training
                    fee; Rental/Co-working space; Technology Transfer Fee, Funds
                    from CSR / NGOs etc)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.revenueModelStatus)"
                    [style.background]="pickColor(getValue.revenueModelStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.revenueModelStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Revenue Model / Fund generation for Sustainability
                      (Training fee; Rental/Co-working space; Technology
                      Transfer Fee, Funds from CSR / NGOs etc)
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.revenueModelStatus != 2 &&
                        getValue.revenueModelStatus != 4 &&
                        getValue.revenueModelStatus != 5 &&
                        getValue.revenueModelStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="revenueModelIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Optionsfivechecked"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.revenueModelIncCentre.touched &&
                              setting.revenueModelIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.revenueModelIncCentre.touched &&
                            setting.revenueModelIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.revenueModelIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Optionsfivechecked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >List of Revenue Models / Fund generation for
                                sustaining the Incubator
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of Revenue Models / Fund generation"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="revenueModelNumbers"
                                (change)="
                                  setStatus($event, 'revenueModelStatus', 7)
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.revenueModelNumbers.touched &&
                                    setting.revenueModelNumbers.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.revenueModelNumbers.touched &&
                                  setting.revenueModelNumbers.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.revenueModelNumbers.errors.required
                                  "
                                  >No of Revenue Models / Fund generation</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="revenueModelImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.revenueModelImagefile.touched &&
                                        setting.revenueModelImagefile.errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.revenueModelImagefile.touched &&
                                    setting.revenueModelImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.revenueModelImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.revenueModelStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="viewReasonBtn(getValue.revenueModelReason)"
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.revenueModelStatus == 2 ||
                        getValue.revenueModelStatus == 4 ||
                        getValue.revenueModelStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.revenueModelIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            List of Revenue Models / Fund generation for
                            sustaining the Incubator :
                            <b>{{ getValue.revenueModelNumbers }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.revenueModelDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.revenueModelStatus == 3 ||
                            getValue.revenueModelStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.revenueModelReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>

              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 010 -->
            <mat-expansion-panel [expanded]="step === 9" (opened)="setStep(9)">
              <mat-expansion-panel-header class="d-flex">
                <h6>10.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Additional Projects for the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.additionalprojectsStatus)"
                    [style.background]="
                      pickColor(getValue.additionalprojectsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.additionalprojectsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Additional Projects for the Incubation Centre</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.additionalprojectsStatus != 2 &&
                        getValue.additionalprojectsStatus != 4 &&
                        getValue.additionalprojectsStatus != 5 &&
                        getValue.additionalprojectsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="additionalprojectsCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          [(ngModel)]="Options10checked"
                          (change)="
                            showOptions10(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.additionalprojectsCentre.touched &&
                              setting.additionalprojectsCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.additionalprojectsCentre.touched &&
                            setting.additionalprojectsCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.additionalprojectsCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" [ngSwitch]="Options10checked">
                        <div class="row" *ngSwitchCase="'Yes'">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Projects
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No of Projects "
                                (change)="
                                  setStatus(
                                    $event,
                                    'additionalprojectsStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="additionalprojectsNoofprojects"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.additionalprojectsNoofprojects
                                      .touched &&
                                    setting.additionalprojectsNoofprojects
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.additionalprojectsNoofprojects
                                    .touched &&
                                  setting.additionalprojectsNoofprojects.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.additionalprojectsNoofprojects
                                      .errors.required
                                  "
                                  >No. of Project</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="additionalprojectsImagefile"
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.additionalprojectsImagefile
                                          .touched &&
                                        setting.additionalprojectsImagefile
                                          .errors
                                    }"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    id=""
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.additionalprojectsImagefile
                                      .touched &&
                                    setting.additionalprojectsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.additionalprojectsImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.additionalprojectsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.additionalprojectsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.additionalprojectsStatus == 2 ||
                        getValue.additionalprojectsStatus == 4 ||
                        getValue.additionalprojectsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.additionalprojectsCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Projects :
                            <b>{{ getValue.additionalprojectsNoofprojects }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.additionalprojectsdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.additionalprojectsStatus == 3 ||
                            getValue.additionalprojectsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.additionalprojectsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[9])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
